import React from 'react';
import { Zap } from 'lucide-react';
import { FadeIn } from './ui/FadeIn';
export function MechanismSection() {
  return <section className="bg-[#FDFAF5] py-20 px-4" data-id="element-121">
      <div className="max-w-[720px] mx-auto" data-id="element-122">
        <FadeIn data-id="element-123">
          <div className="flex items-center justify-center gap-3 mb-6" data-id="element-124">
            <Zap className="w-8 h-8 text-[#4A7C42]" data-id="element-125" />
            <h2 className="text-3xl md:text-4xl font-bold text-[#1A1A1A] text-center" data-id="element-126">
              El Vacío Bioquímico de 72 Horas
            </h2>
          </div>
        </FadeIn>

        <FadeIn delay={0.1} data-id="element-127">
          <div className="bg-white p-8 rounded-3xl shadow-lg border-2 border-[#2D5A27] relative overflow-hidden mt-10" data-id="element-128">
            <div className="absolute top-0 right-0 w-32 h-32 bg-[#E8F5E2] rounded-bl-full -z-0 opacity-50" data-id="element-129"></div>

            <div className="relative z-10 space-y-6 text-lg text-[#5A5A5A] leading-relaxed" data-id="element-130">
              <p data-id="element-131">
                El <strong data-id="element-132">"Vacío Bioquímico de 72 Horas"</strong> es un método
                de intervención rápida diseñado para silenciar la alarma de tu
                sistema inmune. No se trata de comer menos, sino de comer con un
                propósito mecánico.
              </p>
              <p data-id="element-133">
                Al retirar estratégicamente los estímulos irritantes y
                sustituirlos por nutrientes de absorción inmediata, permitimos
                que tu sistema linfático drene el exceso de líquido acumulado.
              </p>
              <div className="bg-[#E8F5E2] p-6 rounded-xl border border-[#4A7C42]/30 text-[#1A1A1A] font-medium italic" data-id="element-134">
                Es como presionar el botón de "reinicio" en tu metabolismo,
                permitiendo que tu abdomen recupere su forma natural mientras
                tus niveles de energía se disparan al dejar de luchar contra la
                inflamación constante.
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}